import StaticPageLayout from './StaticPageLayout';

export default function DataProtectionPage() {
  return <StaticPageLayout title="Datenschutz"></StaticPageLayout>;
}
